<template>
  <div>
    <aside v-if="$store.state.user.userId != ''" class="aside aside-fixed" 
    :class="{
      'minimize': $store.state.app.aside.minimize, 
      'maximize': $store.state.app.aside.maximize,
      'aside-filemgr': $store.state.app.aside.filemgr
    }"
    @mouseover="changeAside($store.state.app.aside.minimize, $store.state.app.aside.minimize?true: false)"
    @mouseleave="changeAside($store.state.app.aside.minimize, false)">
      <div class="aside-header">
        <a href="/" class="aside-logo">Dynamic<span>3.0</span></a>
        <a @click.stop="changeAside(!$store.state.app.aside.minimize, $store.state.app.aside.maximize)" class="aside-menu-link">
          <i data-feather="menu"></i>
          <i data-feather="x"></i> 
        </a>
      </div>
      <vue-custom-scrollbar class="aside-body" style="height: calc(100vh - 59px);" @mouseenter="asideEnter">
        <div class="aside-loggedin">
          <div class="d-flex align-items-center justify-content-start">
            <a href="javascript: void(0)" class="avatar"><img :src="$store.state.user.userInfo.avator" class="rounded-circle" alt=""></a>
            <div class="aside-alert-link">
              <!-- <a href="javascript: void(0)" class="new" data-toggle="tooltip" title="You have 2 unread messages"><i data-feather="message-square"></i></a> -->
              <a @click="$router.push({name: 'notification' })" role="button" :class="{'new': tasksCountUnseen>0}" data-toggle="tooltip" :title="'Идэвхтэй '+ tasksCount +' ажилбар, үзээгүй '+ tasksCountUnseen +' ажилбар байна'"><i data-feather="bell"></i></a>
              <a @click="logout" data-toggle="tooltip" role="button" title="Гарах"><i data-feather="log-out"></i></a>
            </div>
          </div>
          <div class="aside-loggedin-user">
            <a href="#loggedinMenu" class="d-flex align-items-center justify-content-between mg-b-2" data-toggle="collapse">
              <h6 class="tx-semibold mg-b-0">{{$store.state.user.userInfo.fullName}}</h6>
              <i data-feather="chevron-down"></i>
            </a>
            <p class="tx-color-03 tx-12 mg-b-0">{{$store.state.user.userInfo.position}}</p>
          </div>
          <div class="collapse" id="loggedinMenu" :class="{'show': $route.name=='settings' }">
            <ul class="nav nav-aside mg-b-0">
              <li class="nav-item"><a href="javascript: void(0)" class="nav-link"><i data-feather="edit"></i> <span>Мэдээлэл шинэчлэх</span></a></li>
              <li class="nav-item"><a class="nav-link"><i data-feather="user"></i> <span>Хувийн мэдээлэл</span></a></li>
              <li class="nav-item" :class="{'active': $route.name=='settings' }"><a @click="$router.push({name: 'settings', params: { mode: '2'} })" role="button" class="nav-link"><i data-feather="settings"></i> <span>Тохиргоо</span></a></li>
              <li class="nav-item"><a href="http://doc.gosmart.mn" target="_blank" class="nav-link"><i data-feather="help-circle"></i> <span>Гарын авлага</span></a></li>
              <li class="nav-item"><a @click="logout" role="button" class="nav-link"><i data-feather="log-out"></i> <span>Гарах</span></a></li>
            </ul>
          </div>
        </div><!-- aside-loggedin -->
        <!-- {{isVet}}
        v-if="isVet" :key="isVetKey" -->
        <ul class="nav nav-aside">
          <li class="nav-label">Хүсэлтүүд</li>
          <li v-if="!menu.vet.meesbul" class="nav-item" :class="{'active': $route.name=='home'}"><a @click="$router.push({name: 'home'})" role="button" class="nav-link"><i data-feather="bar-chart-2"></i> <span>Статистик</span></a></li>
          <li v-if="(!menu.vet.meesbul) && (!menu.vet.pharma)" class="nav-item pd-t-10" :class="{'active': $route.name=='vetMedSpecial'}"><a @click="turnToPage({name: 'vetMedSpecial', params: { ot: 468 } })" role="button" class="nav-link"><i data-feather="award"></i> <span class="lh-1">Тусгай зөвшөөрлийн <br />хүсэлтүүд</span></a></li>
          <li class="nav-item pd-t-10" :class="{'active': $route.name=='vetMedListReq'}"><a @click="turnToPage({name: 'vetMedListReq', params: { ot: 465 } })" role="button" class="nav-link"><i data-feather="tag"></i> <span class="lh-1">Эм, бэлдмэл бүртгүүлэх<br />хүсэлтүүд</span></a></li>          
          <li v-if="(!menu.vet.meesbul) && (!menu.vet.pharma) && (!menu.vet.zuvlul)" class="nav-item pd-t-10" :class="{'active': $route.name=='vetMedSample'}"><a @click="turnToPage({name: 'vetMedSample', params: { ot: 479 } })" role="button" class="nav-link"><i data-feather="droplet"></i> <span class="lh-1">Дээж импортлох <br />хүсэлтүүд</span></a></li>
          <li v-if="(!menu.vet.meesbul) && (!menu.vet.pharma) && (!menu.vet.zuvlul)" class="nav-item pd-t-10" :class="{'active': $route.name=='vetMedLics'}"><a @click="turnToPage({name: 'vetMedLics', params: { ot: 467 } })" role="button" class="nav-link"><i data-feather="truck"></i> <span class="lh-1">Эм, бэлдмэл импортлох <br/>лицензийн хүсэлтүүд</span></a></li>          
          <template v-if="(!menu.vet.meesbul) && (!menu.vet.pharma) && (!menu.vet.zuvlul)">
            <li class="nav-label mg-t-25">Компани</li>
            <li class="nav-item" :class="{'active': $route.name=='vetMedList'}"><a @click="turnToPage({name: 'vetMedList', params: { ot: 463 } })" role="button" class="nav-link"><i data-feather="layers"></i> <span>Компаниуд</span></a></li>
            <li class="nav-item" :class="{'active': $route.name=='vetMedMy'}"><a @click="turnToPage({name: 'vetMedMy', params: { ot: 478 } })" role="button" class="nav-link"><i data-feather="award"></i> <span>Тусгай зөвшөөрөл</span></a></li>
          </template>
          
          <template v-if="(!menu.vet.meesbul) && (!menu.vet.pharma) && (!menu.vet.zuvlul)">
            <li class="nav-label mg-t-25">Бүртгэл</li>
            <li class="nav-item pd-t-10" :class="{'active': $route.name=='vetMedAcceptedOrgLicences'}"><a @click="turnToPage({name: 'vetMedAcceptedOrgLicences', params: { ot: 476 } })" role="button" class="nav-link"><i data-feather="umbrella"></i> <span class="lh-1">Олгогдсон тусгай<br /> зөвшөөрлүүд</span></a></li>
            <li class="nav-item" :class="{'active': $route.name=='vetMedMedicine'}"><a @click="turnToPage({name: 'vetMedMedicine', params: { ot: 472 } })" role="button" class="nav-link"><i data-feather="activity"></i> <span>Бүртгэлтэй эмүүд</span></a></li>
            <li class="nav-item pd-t-10" :class="{'active': $route.name=='vetMedAcceptedSamples'}"><a @click="turnToPage({name: 'vetMedAcceptedSamples', params: { ot: 481 } })" role="button" class="nav-link"><i data-feather="octagon"></i> <span class="lh-1">Бүртгэлтэй<br /> дээжүүд</span></a></li>
            <li class="nav-item pd-t-10" :class="{'active': $route.name=='vetMedAcceptedMeds'}"><a @click="turnToPage({name: 'vetMedAcceptedMeds', params: { ot: 477 } })" role="button" class="nav-link"><i data-feather="truck"></i> <span class="lh-1">Эм, бэлдмэл импортлох<br /> лиценз</span></a></li>                        
          </template>
          <template v-if="menu.vet.admin">
            <li class="nav-label mg-t-25">Хүний нөөц</li>
            <li class="nav-item" :class="{'active': $route.name=='vetMedUsers'}"><a @click="turnToPage({name: 'vetMedUsers', params: { ot: 138 } })" role="button" class="text-muted nav-link"><i data-feather="users"></i> <span>Жагсаалт</span></a></li>
          </template>

          <li class="nav-label mg-t-25">Систем</li>
          <li class="nav-item" :class="{'active': $route.name=='mediaHome'}"><a @click="turnToPage({name: 'mediaHome' })" role="button" class="text-muted nav-link"><i data-feather="archive"></i> <span>Динамик драйв</span></a></li>
          <li v-if="!menu.vet.client" class="nav-item" :class="{'active': $route.name=='vidConference'}"><a @click="turnToPage({name: 'vidConference', params: { ot: 493 } })" role="button" class="nav-link"><i data-feather="video"></i> <span class="lh-1">Видео хурал</span></a></li>
          <li v-if="!menu.vet.client" class="nav-item" :class="{'active': $route.name=='sysReports'}"><a @click="turnToPage({name: 'sysReports', params: { ot: 451 } })" role="button" class="nav-link"><i data-feather="bar-chart-2"></i> <span class="lh-1">Тайлан мэдээ</span></a></li>
        </ul>
        <!-- <main-menu v-else /> -->
        <main-menu v-if="1==2" />
      </vue-custom-scrollbar>
    </aside>
    
    <header v-else-if="$route.meta.header==undefined" class="navbar navbar-header navbar-header-fixed" :class="{'bd-b-0': $route.name=='monicpa'}">
      <a href="javascript: void(0)" id="mainMenuOpen" class="burger-menu"><i data-feather="menu"></i></a>
      <div class="navbar-brand" style="padding: 0">
        <a href="/" role="button"><img src="https://res.gosmart.mn/apps/vet.med/logo.png" /></a>
      </div>
      <div id="navbarMenu" class="navbar-menu-wrapper withicon">
        <div class="navbar-menu-header">
          <a href="#" class="df-logo">мал<span>эмнэлэг</span></a>
          <a id="mainMenuClose" href="javascript: void(0)"><i data-feather="x"></i></a>
        </div>
        <ul class="nav navbar-menu ">
          <li class="nav-label pd-l-15 pd-lg-l-25 d-lg-none">Үндсэн цэс</li>
          <li class="nav-item"><a href="/" class="nav-link" style="cursor:pointer"><i data-feather="home"></i> Эхлэл</a></li>
          <li class="nav-item" :class="{'active': $route.name=='vetLandingMeds' }">
            <a @click="turnToPage({name: 'vetLandingMeds' })" class="nav-link"  style="cursor:pointer"><i data-feather="droplet"></i> Бүртгэлтэй эм, бэлдмэл</a>
          </li>          
          
          <li class="nav-item" :class="{'active': $route.name=='vetLandingLics' }"><a @click="turnToPage({name: 'vetLandingLics' })" class="nav-link" style="cursor:pointer"><i data-feather="box"></i> Тусгай зөвшөөрөл</a></li>
          <li class="nav-item" ><a href="http://help.vetdrug.mn" target="_blank" class="nav-link"  style="cursor:pointer"><i data-feather="help-circle"></i> Гарын авлага</a></li>
          <li class="nav-item" ><a href="http://help.vetdrug.mn/#/vet-landing-help/45047/1377723" target="_blank" class="nav-link"><i data-feather="monitor"></i> <span>Бүртгүүлэх</span></a></li>
        </ul>
      </div>
      <div class="navbar-right">
        <button @click="$router.push({name: 'login'})" class="btn btn-buy"><i data-feather="log-in"></i> <span>Системд нэвтрэх</span></button>
      </div>
    </header>
    
    <router-view></router-view>
    <footer class="footer" v-if="$store.state.user.userId == '' && $route.name!='vetLandingHelp'">
      <div>
        
        <span>&copy; 2020 Динамик платформ v3.1.0.</span>
        <!-- <span>Developed by <a href="http://gosmart.mn" target="_blank">All Ink</a></span> -->
      </div>
      <div>
        <nav class="nav">
          <a href="#" class="nav-link">Үйлчилгээний нөхцөл</a>
          <a href="#" class="nav-link">Шинэчлэл</a>
          <a href="#" class="nav-link">Гарын авлага</a>
        </nav>
      </div>
    </footer>
    <b-overlay :show="$store.state.app.loading" no-wrap fixed />
    <div class="aside-backdrop"></div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { hasOneOf } from "@/libs/tools";
import { request } from "@/api/all";

import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

export default {
  name: "App",

  components: {
    vueCustomScrollbar,
    mainMenu: () => ({
      component: import("@/views/main/menu.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
  },

  data: () => ({
    menu:{
      vet:{
        admin: false,
        client: false,
        meesbul: false,
        pharma: false,
        zuvlul: false,
      }
    },
    tasksCount: 0,
    tasksCountUnseen: 0,
    isVet: false,
    isVetKey: 0,
  }), 
  mounted() {
    if (document.location.hostname == "vetdrug.mn" || document.location.hostname == "www.vetdrug.mn" 
    || document.location.hostname == "192.168.0.105"
    ) {
      
      this.$nextTick(function() {
        this.isVet = true;
        this.isVetKey++;
        console.log('this.isVet', this.isVet, document.location.hostname);
      });
    }
    
    this.$nextTick(function () {
      this.featherReplace();

      if(this.$store.state.user.userId != ''){
        let asideScript = document.createElement('script')
        asideScript.setAttribute('src', 'https://res.gosmart.mn/da/assets/js/dashforge.aside.js')
        document.head.appendChild(asideScript)
      }
    })
    this.buildMenu();
    this.initCounts();
  },
  updated(){
    this.featherReplace();
  },
  methods: {
    ...mapActions([
      "handleLoading",
      'handleAside',
      "handleLogOut",
      'handleDynamicMenuLoaded'
    ]),
    featherReplace(){
      let platformScript = document.createElement('script')
      platformScript.setAttribute('src', 'https://res.gosmart.mn/da/assets/js/dashforge.js')
      document.head.appendChild(platformScript)
    },
    initCounts(){
      if(this.$store.state.user.userId!=''){
        request({
          api: { method: "get", url: "task/GetPinnedTaskCount" },
          store: this.$store
        }).then(res => {
          if (res != false) {              
            this.tasksCount= res.data.count;
            this.tasksCountUnseen= res.data.unseenCount;
            //console.log(res);
          }
        });
      }
    },
    buildMenu(){
      //console.log(this.$router.options.routes);
      //console.log(this.$store.state.user.access);
      if(hasOneOf(['vetmedadmin'], this.$store.state.user.access)){
        this.menu.vet.admin= true;
      }
      if(hasOneOf(["vetmedmeesbul"], this.$store.state.user.access)){        
        this.menu.vet.meesbul= true;
      }
      if(hasOneOf(["vetmedpharma"], this.$store.state.user.access)){        
        this.menu.vet.pharma= true;
      }
      if(hasOneOf(["vetmedzuvlul"], this.$store.state.user.access)){        
        this.menu.vet.zuvlul= true;
      }
    },
    logout() {
      this.handleLoading({ isLoading: true });
      this.handleLogOut().then(res => {
        if (res != false) {
          this.handleDynamicMenuLoaded(false);
          this.handleLoading({ isLoading: false });
          this.$router.push({ name: "login" });
        }
      });
    },
    changeAside(mi, ma){
      this.handleAside({ minimize: mi, maximize: ma });
    },
    asideEnter(){
      // if(this.$store.state.app.aside.minimize){
      //   window.$('.aside').parent().addClass('maximize');
      // }
    },
    turnToPage(route){
      let { name, params, query } = {};
      if (typeof route === "string") name = route;
      else {
        name = route.name;
        params = route.params;
        query = route.query;
      }

      if(this.$route.name!=route.name)
        this.$router.push({ name, params, query });
    },
  },
  computed: {
    userId () {
      return this.$store.state.user.userId;
    }
  },
  watch: {
    userId: function(newVal, oldVal) {
      //console.log(newVal, oldVal);
      if(oldVal!=newVal){
        Object.assign(this.$data, this.$options.data());
        this.initCounts();
        this.buildMenu();
      }
    }
  },
};
</script>
<style>
.withicon .navbar-menu .nav-link svg {
    display: block;
    padding-right: 2px;
    margin-right: 5px;
    margin-top: -3px;
}
</style>